export enum SalesOrderLineHistoricalFieldsEnum {
	Status = 'Status'
}